export default "__VITE_ASSET__ab213737__"